export default __webpack_public_path__ + "static/media/spin_stop.b5450903.mp3";